// TODO: após clonar o skeleton, ajustar os links de ambientes

const dev = {
	API_ENDPOINT_URL: "https://carbon-smart-back-hgcjm.ondigitalocean.app/carbonsmart/api",
	PUBLIC_PREFIX_PATH: "",
};

const getProdApiEndpoint = () => {
	// Em produção, usa o mesmo host do front para evitar drift de domínio.
	// if (typeof window !== "undefined" && window.location?.origin) {
	// 	return `${window.location.origin}/carbonsmart/api`;
	// }
	return "https://carbon-smart-back-hgcjm.ondigitalocean.app/carbonsmart/api";
};

const prod = {
	API_ENDPOINT_URL: getProdApiEndpoint(),
	PUBLIC_PREFIX_PATH: "",
};

const test = {
	API_ENDPOINT_URL: "",
	PUBLIC_PREFIX_PATH: "",
};

const getEnv = () => {
	switch (process.env.REACT_APP_ENV) {
		case "development":
			return dev;
		case "production":
			return prod;
		case "test":
			return test;
		default:
			return dev;
	}
};

export const env = getEnv();
